import React, { useState, useEffect } from 'react';
import './BlackberryReviews.scss';
import { FaStar } from 'react-icons/fa';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';

// ... reviewsData array remains the same ...
const reviewsData = [
    {
        id: 1,
        name: 'Kritika Singh',
        review: 'I love the quality of the fabric and the fit is perfect. I would definitely recommend this product to my friends.',
        rating: 5,
        icon: <FaStar color="yellow" />,
        image: '/assets/img/elnora/23.png'
    },
    {
        id: 2,
        name: 'Aarti Singh',
        review: 'The product is of good quality and the fit is perfect. I would definitely recommend this product to my friends.',
        rating: 4,
        icon: <FaStar color="yellow" />,
        image: '/assets/img/elnora/31.png'
    },
    {
        id: 3,
        name: 'Riya Patel',
        review: 'It was a great experience with the product. The quality is good and the fit is perfect. I would definitely recommend this product to my friends.',
        rating: 3,
        icon: <FaStar color="yellow" />,
        image: '/assets/img/elnora/19.png'
    },
    {
        id: 4,
        name: 'Rhea Bansal',
        review: 'The product is of good quality and the fit is perfect. I would definitely recommend this product to my friends.',
        rating: 2,
        icon: <FaStar color="yellow" />,
        image: '/assets/img/elnora/24.png'
    },
    {
        id: 5,
        name: 'Sneha Verma',
        review: 'The product is of good quality and the fit is perfect. I would definitely recommend this product to my friends.',
        rating: 1,
        icon: <FaStar color="yellow" />,
        image: '/assets/img/elnora/23.png'
    },
    {
        id: 6,
        name: 'Vinita Sharma',
        review: 'The product is of good quality and the fit is perfect. I would definitely recommend this product to my friends.',
        rating: 0,
        icon: <FaStar color="yellow" />,
        image: '/assets/img/elnora/23.png'
    },
    {
        id: 7,
        name: 'Sangeeta Patel',
        review: 'The product is of good quality and the fit is perfect. I would definitely recommend this product to my friends.',
        rating: 0,
        icon: <FaStar color="yellow" />,
        image: '/assets/img/elnora/23.png'
    },
    {
        id: 8,
        name: 'Tanya Gupta',
        review: 'The product is of good quality and the fit is perfect. I would definitely recommend this product to my friends.',
        rating: 0,
        icon: <FaStar color="yellow" />,
        image: '/assets/img/elnora/23.png'
    },
    {
        id: 9,
        name: 'Neelam Singh',
        review: 'The product is of good quality and the fit is perfect. I would definitely recommend this product to my friends.',
        rating: 0,
        icon: <FaStar color="yellow" />,
        image: '/assets/img/elnora/23.png'
    },
    {
        id: 10,
        name: 'Srishti Verma',
        review: 'The product is of good quality and the fit is perfect. I would definitely recommend this product to my friends.',
        rating: 0,
        icon: <FaStar color="yellow" />,
        image: '/assets/img/elnora/23.png'
    },
    {
        id: 11,
        name: 'Nikita Sharma',
        review: 'The product is of good quality and the fit is perfect. I would definitely recommend this product to my friends.',
        rating: 0,
        icon: <FaStar color="yellow" />,
        image: '/assets/img/elnora/23.png'
    },
    {
        id: 12,
        name: 'Prachi Gill',
        review: 'The product is of good quality and the fit is perfect. I would definitely recommend this product to my friends.',
        rating: 0,
        icon: <FaStar color="yellow" />,
        image: '/assets/img/elnora/23.png'
    },
]

const BlackberryReviews = () => {
    const [currentGroup, setCurrentGroup] = useState(0);
    const [cardsPerGroup, setCardsPerGroup] = useState(4);
    
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 480) { // mobile and small mobile
                setCardsPerGroup(1);
            } else if (window.innerWidth <= 768) { // tablet
                setCardsPerGroup(2);
            } else if (window.innerWidth <= 1024) { // small laptop
                setCardsPerGroup(3);
            } else { // laptop and larger
                setCardsPerGroup(4);
            }
        };

        handleResize(); // Initial check
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const totalGroups = Math.ceil(reviewsData.length / cardsPerGroup);

    const nextGroup = () => {
        setCurrentGroup((prev) => (prev + 1) % totalGroups);
    };

    const prevGroup = () => {
        setCurrentGroup((prev) => (prev - 1 + totalGroups) % totalGroups);
    };

    const getCurrentGroupCards = () => {
        const startIndex = currentGroup * cardsPerGroup;
        return reviewsData.slice(startIndex, startIndex + cardsPerGroup);
    };

    return (
        <div className="bb-reviews">
            <div className="bb-reviews-container">
                <div className="bb-reviews-header">
                    <h2>Customer Reviews</h2>
                </div>
                <div className="bb-reviews-carousel-container">
                    <button 
                        className="carousel-button prev" 
                        onClick={prevGroup}
                        aria-label="Previous reviews"
                    >
                        <IoIosArrowBack />
                    </button>
                    
                    <div className="bb-reviews-grid">
                        {getCurrentGroupCards().map((review) => (
                            <div 
                                key={review.id} 
                                className="bb-reviews-card"
                            >
                                <div className="bb-reviews-card-header">
                                    <div className="customer-image">
                                        <img src={review.image} alt={review.name} />
                                    </div>
                                    <div className="customer-info">
                                        <h4>{review.name}</h4>
                                    </div>
                                </div>
                                <div className="bb-reviews-card-rating">
                                    {[...Array(5)].map((_, index) => (
                                        <FaStar
                                            key={index}
                                            color={index < review.rating ? "#D4AF37" : "#E6E6E6"}
                                        />
                                    ))}
                                </div>
                                <div className="bb-reviews-card-review">
                                    {review.review}
                                </div>
                            </div>
                        ))}
                    </div>

                    <button 
                        className="carousel-button next" 
                        onClick={nextGroup}
                        aria-label="Next reviews"
                    >
                        <IoIosArrowForward />
                    </button>
                </div>

                {/* Carousel Indicators */}
                <div className="carousel-indicators">
                    {[...Array(totalGroups)].map((_, index) => (
                        <button
                            key={index}
                            className={`indicator ${currentGroup === index ? 'active' : ''}`}
                            onClick={() => setCurrentGroup(index)}
                            aria-label={`Go to review group ${index + 1}`}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default BlackberryReviews;